import './polyfills'
import './index.css'
import { createRoot } from 'react-dom/client'
import ChatWidget from './ChatWidget'

const container = document.getElementById('tovobot-widget-root')
if(container) {
    const root = createRoot(container)
    root.render(<ChatWidget />)
}